import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Paper, Typography } from "@mui/material";
import Forward5RoundedIcon from "@mui/icons-material/Forward5Rounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import DonutLargeRoundedIcon from "@mui/icons-material/DonutLargeRounded";
import PestControlRoundedIcon from "@mui/icons-material/PestControlRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../FirebaseConfig";
import "./ShowIssuesStyles.css";

const ShowIssues = () => {
  const [issues, setIssues] = useState([]);
  const [selectedIssueId, setSelectedIssueId] = useState(null);
  const navigate = useNavigate();

  const dropdownData = [
    { id: 1, label: "Ongoing" },
    { id: 2, label: "Bug" },
    { id: 3, label: "Complete" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "Issues"));
        const issuesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          dropdownVisible: false,
          selectedItem: null,
          iconChecked: false,
        }));
        setIssues(issuesData);
      } catch (error) {
        console.error("Error fetching issues:", error);
      }
    };

    fetchData();
  }, []);

  const handleContainerClick = (issueId) => {
    navigate(`/showissueslist/${issueId}`);
  };

  const handleButtonClick = (event, issueId) => {
    event.stopPropagation();
    const updatedIssues = issues.map((issue) => {
      if (issue.id === issueId) {
        if (!issue.selectedItem) {
          const ongoingItem = dropdownData.find(
            (item) => item.label === "Ongoing"
          );
          return {
            ...issue,
            selectedItem: ongoingItem,
            iconChecked: true,
            dropdownVisible: false,
          };
        } else {
          return {
            ...issue,
            dropdownVisible: !issue.dropdownVisible,
          };
        }
      }
      return {
        ...issue,
        dropdownVisible: false,
      };
    });
    setIssues(updatedIssues);
  };

  const handleItemClick = (issueId, item) => {
    const updatedIssues = issues.map((issue) => {
      if (issue.id === issueId) {
        return {
          ...issue,
          selectedItem: item,
          dropdownVisible: false,
          iconChecked: item.label === "Ongoing",
        };
      }
      return issue;
    });
    setIssues(updatedIssues);
  };

  const renderIcon = (selectedItem, iconChecked) => {
    if (selectedItem) {
      switch (selectedItem.label) {
        case "Ongoing":
          return <DonutLargeRoundedIcon />;
        case "Complete":
          return <CheckCircleRoundedIcon />;
        case "Bug":
          return <PestControlRoundedIcon />;
        default:
          return null;
      }
    } else {
      return iconChecked ? <CheckRoundedIcon /> : <CloseRoundedIcon />;
    }
  };

  return (
    <Grid container spacing={2}>
      {issues.map((issue) => (
        <Grid item xs={12} sm={6} md={4} key={issue.id}> 
          <Paper className="issue-paper" onClick={() => handleContainerClick(issue.id)}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" ,position: "relative"}}>
              <Typography sx={{ fontWeight: "bold" ,fontSize: "18px"}}>{issue.title}</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <Forward5RoundedIcon />
                {renderIcon(issue.selectedItem, issue.iconChecked)}
                <div className="button-container">
                  <div
                    onClick={(event) => handleButtonClick(event, issue.id)}
                    style={{ marginTop: "0" }}
                  >
                    {issue.selectedItem ? issue.selectedItem.label : "Accept"}
                  </div>
                </div>

                {issue.dropdownVisible && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      position: "absolute",
                      top: "80%",
                      right: "0",
                      width: "200px",
                      backgroundColor: "#fff",
                      border: "1px solid black",
                      borderRadius: "4px",
                      overflow: "hidden",
                      zIndex: "99999",
                    }}
                  >
                    <ul
                      style={{
                        listStyle: "none",
                        padding: "10px",
                        margin: "0",
                      }}
                    >
                      {dropdownData.map((item) => (
                        <li
                          key={item.id}
                          onClick={() => handleItemClick(issue.id, item)}
                          style={{ cursor: "pointer" }}
                        >
                          {item.label}
                          <hr
                            style={{
                              padding: "5px",
                              margin: "0px",
                              opacity: "0.5",
                            }}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </Box>
            </Box>

            <p style={{ marginTop: "-8px", marginBottom: "0px" }}>
              <p>Type: {issue.type}</p>
            </p>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default ShowIssues;
